import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ArticleManageService extends BaseService {

  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  // --- Syllabus (Categories) ---
  getSyllabus() {
    return this.get('/v3/api/articles-manage/syllabus');
  }

  createSyllabus(data: any) {
    return this.post('/v3/api/articles-manage/syllabus', data);
  }

  updateSyllabus(id: number | string, data: any) {
    return this.patch(`/v3/api/articles-manage/syllabus/${id}`, data);
  }

  getSyllabusDetail(id: number | string) {
    return this.get(`/v3/api/articles-manage/syllabus/${id}`);
  }

  deleteSyllabus(id: number | string) {
    return this.remove(`/v3/api/articles-manage/syllabus/${id}`);
  }

  // --- Articles ---
  getArticles(params: any = {}) {
    return this.get('/v3/api/articles-manage/articles', params);
  }

  createArticle(data: any) {
    return this.post('/v3/api/articles-manage/articles', data);
  }

  getArticleDetail(id: number | string) {
    return this.get(`/v3/api/articles-manage/articles/${id}`);
  }

  updateArticle(id: number | string, data: any) {
    return this.patch(`/v3/api/articles-manage/articles/${id}`, data);
  }

  deleteArticle(id: number | string) {
    return this.remove(`/v3/api/articles-manage/articles/${id}`);
  }

  // --- Tags ---
  getTags(params: any = {}) {
    return this.get('/v3/api/tags/article/list', params);
  }

  checkTagName(name: string) {
    return this.get('/v3/api/tags/article/check/name', { name });
  }

  saveTag(data: any) {
    return this.post('/v3/api/tags/article/item/save', data);
  }

  deleteTag(id: number | string) {
    return this.post('/v3/api/tags/article/item/delete', { id });
  }
}

